module.exports = __webpack_public_path__ + "img/0Q3B2213_Foamcore.4812ef79.jpg";